webpackJsonp([82519006201453],{

/***/ 203:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.chicagoImageQuery = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyImage = __webpack_require__(12);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _HeroSmall = __webpack_require__(8);
	
	var _HeroSmall2 = _interopRequireDefault(_HeroSmall);
	
	var _LocationMicroNav = __webpack_require__(10);
	
	var _LocationMicroNav2 = _interopRequireDefault(_LocationMicroNav);
	
	var _LocationContent = __webpack_require__(9);
	
	var _LocationContent2 = _interopRequireDefault(_LocationContent);
	
	var _LocationRelated = __webpack_require__(11);
	
	var _LocationRelated2 = _interopRequireDefault(_LocationRelated);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ChicagoLocation = function (_React$Component) {
	  _inherits(ChicagoLocation, _React$Component);
	
	  function ChicagoLocation() {
	    _classCallCheck(this, ChicagoLocation);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  ChicagoLocation.prototype.render = function render() {
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(_HeroSmall2.default, { location: 'Chicago, IL' }),
	      _react2.default.createElement(_LocationMicroNav2.default, null),
	      _react2.default.createElement(_LocationContent2.default, {
	        category: 'E-bikes',
	        title: 'Plugged In',
	        story: 'We headed to the Windy City to meet with industry leaders to outline objectives and priorities for regulating electric mountain bikes. The outcomes of this meeting included the development and marketing of an eMTB map which directs riders to legal places to ride e-bikes off road. We also collectively agreed to build awareness and understanding of eMTBs among federal, state and local managers through demos, presentations, and summits.'
	      }),
	      _react2.default.createElement(_gatsbyImage2.default, {
	        title: 'Chicago',
	        alt: 'Chicago bike scene',
	        sizes: this.props.data.chicagoOneOneImage.sizes
	      }),
	      _react2.default.createElement(_LocationRelated2.default, {
	        prevLocationName: 'Las Vegas, NV',
	        prevLocationPath: 'las-vegas',
	        prevLocationImgPath: this.props.data.chicagoPrevImage,
	        nextLocationName: 'Colorado',
	        nextLocationPath: 'colorado',
	        nextLocationImgPath: this.props.data.chicagoNextImage
	      })
	    );
	  };
	
	  return ChicagoLocation;
	}(_react2.default.Component);
	
	exports.default = ChicagoLocation;
	var chicagoImageQuery = exports.chicagoImageQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-chicago-js-78cb15e74eee14b0d99b.js